//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { dicOption, colorOption } from '@/views/visual/dataScreen/js/option/config';
export default {
  inject: ["main"],
  data: function data() {
    return {
      dicOption: dicOption,
      colorOption: colorOption
    };
  },
  methods: {
    rowSave: function rowSave(row, done) {
      this.main.activeOption.barColor.push(this.deepClone(row));
      done();
    },
    rowDel: function rowDel(row, index) {
      this.main.activeOption.barColor.splice(index, 1);
    },
    rowUpdate: function rowUpdate(row, index, done) {
      this.main.activeOption.barColor.splice(index, 1, this.deepClone(row));
      done();
    }
  }
};